export var GlobalModals;
(function (GlobalModals) {
    GlobalModals["About"] = "about";
    GlobalModals["Help"] = "help";
    GlobalModals["Learning"] = "learning";
    GlobalModals["Support"] = "support";
    GlobalModals["IpsVideo"] = "ips video";
    GlobalModals["Feedback"] = "feedback";
})(GlobalModals || (GlobalModals = {}));
